var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArcade(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leftmenu/games/icon-arcade") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "1.33055874e-13%",
    x2: "50%",
    y2: "104.53891%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.995478029,
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.995478029,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.43058912,20.5481788 C2.2036497,20.5699177 2.00974919,20.760133 2.00974919,21.0128477 L2.00974919,21.9155553 C2.01299892,22.4992446 2.3195567,23.08076 2.94458795,23.3590178 L11.8499292,27.3290834 C13.8571786,28.2236389 16.1449879,28.2236389 18.1522373,27.3290834 L27.0575785,23.3590178 C27.6826098,23.08076 27.9891676,22.4992446 27.9924173,21.9155553 L27.9924173,21.0128477 C27.9924173,20.6758948 27.6452379,20.4514407 27.3386801,20.5883958 L18.1522373,24.6812861 C16.1449879,25.5758416 13.8550121,25.5758416 11.8477627,24.6812861 L2.66348638,20.5883958 C2.58657612,20.554157 2.50641613,20.5411137 2.43058912,20.5481788 L2.43058912,20.5481788 Z M7.11669861,16.4786578 C8.14144655,16.4786578 8.97229398,16.9552831 8.97229398,17.5422332 C8.97229398,18.1291834 8.14252979,18.6036347 7.11669861,18.6036347 C6.09195067,18.6036347 5.26164486,18.1291834 5.26164486,17.5422332 C5.26164486,16.9552831 6.09195067,16.4786578 7.11669861,16.4786578 L7.11669861,16.4786578 Z M13.9167569,11.5471897 C13.2104825,11.6466451 12.5128739,11.8352301 11.8477627,12.130879 L2.94242146,16.1004011 C1.68585951,16.6612646 1.68585951,18.4503755 2.94242146,19.011239 L11.8477627,22.9813046 C13.8550121,23.87586 16.1449879,23.87586 18.1522373,22.9813046 L27.0575785,19.011239 C28.3141405,18.4503755 28.3141405,16.6612646 27.0575785,16.1004011 L18.1522373,12.130879 C17.4871261,11.8341431 16.7906008,11.6466451 16.0832431,11.5471897 L16.0832431,17.4020174 C16.0832431,17.8520125 15.5979502,18.2172259 15,18.2172259 C14.4020498,18.2172259 13.9167569,17.8520125 13.9167569,17.4020174 L13.9167569,11.5471897 Z M15,3 C13.2050662,3 11.7502708,4.45976674 11.7502708,6.26083412 C11.7502708,8.0619015 13.2050662,9.52166824 15,9.52166824 C16.7949338,9.52166824 18.2497292,8.0619015 18.2497292,6.26083412 C18.2497292,4.45976674 16.7949338,3 15,3 L15,3 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-15.4%",
    y: "-8.0%",
    width: "130.8%",
    height: "132.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leftmenu/games/icon-arcade",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArcade);
export default __webpack_public_path__ + "static/media/icon-arcade.8a1ca38e17711dd7d5222ca809db7bbe.svg";
export { ForwardRef as ReactComponent };